import { CLEAR_FORM_TRIGGER_TYPE_ALERT } from 'actions/formTriggerTypeAlert';

function getInitialState() {
  return { showMessagingHeader: true };
}

function formTriggerTypeAlertReducer(state = getInitialState(), action) {
  switch (action.type) {
    case CLEAR_FORM_TRIGGER_TYPE_ALERT: {
      return { ...state, showMessagingHeader: false };
    }
    default:
      return state;
  }
}

export default formTriggerTypeAlertReducer;
